import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { baseColors } from '../../Themes/colors';
import { Stack } from '@mui/material';
export var ViewToggleGroup = styled(Box)(function () { return ({
    display: 'inline-flex',
    borderRadius: 8,
    overflow: 'hidden',
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    backgroundColor: baseColors.fullWhite,
}); });
export var ViewToggleButton = styled('button')(function (_a) {
    var active = _a.active;
    return ({
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 40,
        height: 36,
        border: 'none',
        cursor: 'pointer',
        transition: 'background-color 0.2s',
        backgroundColor: active ? baseColors.successPreset[30] : baseColors.fullWhite,
        color: active ? baseColors.fullWhite : baseColors.greyPreset[20],
        '&:first-of-type': {
            borderRight: "1px solid ".concat(baseColors.greyPreset[40]),
        },
        '& span': {
            fontSize: 18,
            color: active ? baseColors.fullWhite : baseColors.greyPreset[5],
        },
        '&:hover': {
            backgroundColor: active ? baseColors.successPreset[10] : baseColors.greyPreset[45],
        },
    });
});
export var SummaryCardWrapper = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        '& .summaryCard': {
            display: 'flex',
            justifyContent: 'space-between',
            backgroundColor: baseColors.fullWhite,
            borderRadius: 8,
            padding: '12px 16px',
            boxShadow: theme.shadows[1],
            '& .cardIcon': {
                fontSize: 40,
            },
            '& .cardTitleWrapper': {
                gap: 8,
                alignItems: 'center',
                '& .summaryValue': {
                    color: baseColors.bluePreset[10],
                    fontWeight: 600,
                },
                '& span': {
                    fontSize: 24,
                },
                '& .icon-up-arrow': {
                    color: baseColors.errorPreset[10],
                },
                '& .icon-down-arrow': {
                    color: baseColors.successPreset[40],
                },
            },
            '& .summaryTitle': {
                color: baseColors.greyPreset[5],
                fontSize: 18,
                fontWeight: 600,
            },
            '& .summarySub': {
                color: baseColors.greyPreset[10],
            }
        }
    });
});
export var BacklogViewWrapper = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        width: '100%',
        display: 'flex',
        gap: 16,
        overflow: 'hidden',
        '& .backlogMainContent': {
            flex: 1,
            minWidth: 0,
            overflow: 'hidden',
            marginTop: '8px',
            marginBottom: '8px'
        },
        '& .backlogFilters': {
            flexShrink: 0,
            width: 318,
            minWidth: 0,
            marginTop: '8px',
            overflow: 'hidden',
            alignSelf: 'stretch',
        }
    });
});
export var FundingLogDetailsPanelWrapper = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            flexShrink: 0,
            width: 380,
            minWidth: 0,
            overflow: 'hidden',
            border: "1px solid ".concat(baseColors.greyPreset[40]),
            borderRadius: 8,
            backgroundColor: baseColors.fullWhite
        },
        _b[theme.breakpoints.up('lg')] = {
            width: '25%',
            maxWidth: 450,
        },
        _b);
});
export var BacklogGridViewWrapper = styled(Box)(function (_a) {
    var theme = _a.theme;
    return ({
        '& .backlogItemCard': {
            backgroundColor: baseColors.fullWhite,
            padding: 20,
            borderRadius: 8,
        },
        '& .cardFooter': {
            borderTop: "1px solid ".concat(baseColors.greyPreset[40]),
            paddingTop: 8,
            alignItems: 'center',
            justifyContent: 'space-between'
        }
    });
});
export var BacklogTabDetailsWrapper = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            '& .twoColGrid': {
                alignItems: 'flex-start',
                flexWrap: 'nowrap',
            },
            '& .leftCol': {
                flexBasis: '71%',
                maxWidth: '71%',
                minWidth: 0,
            },
            '& .rightCol': {
                flexBasis: '29%',
                maxWidth: '29%',
                minWidth: 300,
                alignSelf: 'flex-start',
            },
            '& .scrollableCol': {
                height: 'calc(100vh - 190px)',
                overflowY: 'auto',
                paddingRight: 8,
            },
            '& .rightScrollableCol': {
                height: 'calc(100vh - 190px)',
                overflowY: 'auto',
                paddingRight: 0,
            },
            '& .commonCardWrapper': {
                backgroundColor: baseColors.fullWhite,
                borderRadius: 8,
                padding: '16px 12px'
            }
        },
        _b[theme.breakpoints.down('lg')] = {
            '& .twoColGrid': {
                flexWrap: 'wrap',
            },
            '& .leftCol, & .rightCol': {
                flexBasis: '100%',
                maxWidth: '100%',
                minWidth: 0,
            },
            '& .scrollableCol, & .rightScrollableCol': {
                height: 'auto',
                maxHeight: 'none',
                overflowY: 'visible',
                paddingRight: 0,
            },
        },
        _b);
});
export var BacklogRightSectionCard = styled(Stack)(function (_a) {
    var theme = _a.theme;
    return ({
        gap: 12,
        padding: '14px 24px',
        backgroundColor: baseColors.fullWhite,
        borderRadius: 8,
    });
});
export var ContractToleranceCard = styled(Box)(function () { return ({
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    borderRadius: 8,
    '& .toleranceHeader': {
        padding: '8px 12px',
        backgroundColor: baseColors.greyPreset[55],
        borderRadius: '8px 8px 0px 0px'
    },
    '& .toleranceBody': {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        padding: '10px 8px',
    },
    '& .toleranceIconWrapper': {
        width: 32,
        height: 32,
        borderRadius: '50%',
        backgroundColor: baseColors.greyPreset[55],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        '& span': {
            fontSize: 20,
            color: baseColors.darkPreset[10],
        },
    },
    '& .toleranceCol': {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
    },
}); });
export var SectionCard = styled(Box)(function () { return ({
    backgroundColor: baseColors.fullWhite,
    borderRadius: 8,
    padding: '12px 16px',
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    minWidth: 0,
    overflow: 'hidden',
}); });
export var StatusPill = styled(Stack)(function () { return ({
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    borderRadius: 4,
    padding: '4px 16px',
    width: '100%',
    '& span': {
        fontSize: 20,
        color: baseColors.fullWhite,
    },
}); });
export var ConditionRow = styled(Stack)(function () { return ({
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    borderRadius: '8px',
    padding: '4px 8px',
    backgroundColor: baseColors.greyPreset[55],
    '& .conditionIcon': {
        fontSize: 20,
        color: baseColors.darkPreset[10],
        flexShrink: 0,
    },
}); });
export var MainTabLayout = styled(Box)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            display: 'flex',
            gap: 16,
            alignItems: 'flex-start',
            '& .mainTabContent': {
                flex: 1,
                minWidth: 0,
                display: 'flex',
                flexDirection: 'column',
                gap: 16,
            }
        },
        _b[theme.breakpoints.down('lg')] = {
            gap: 12,
            '& .mainTabContent': {
                gap: 12,
            },
        },
        _b[theme.breakpoints.down('md')] = {
            flexDirection: 'column',
            '& .mainTabContent': {
                width: '100%',
            },
        },
        _b);
});
export var CommentsWrapper = styled(Box)(function () { return ({
    backgroundColor: baseColors.fullWhite,
    borderRadius: 8,
    border: "1px solid ".concat(baseColors.greyPreset[40]),
    overflow: 'hidden',
    '& .commentsHeader': {
        alignItems: 'center',
        gap: 8,
        borderBottom: "1px solid ".concat(baseColors.greyPreset[40]),
        justifyContent: 'space-between',
        padding: '10px 12px',
        '& .headerIconCircle': {
            width: 32,
            height: 32,
            borderRadius: 12,
            backgroundColor: baseColors.successPreset[30],
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            '& span': {
                color: baseColors.fullWhite,
                fontSize: 18,
            },
        },
        '& .headerActions': {
            alignItems: 'center',
            gap: 8,
            flexShrink: 0,
        },
        '& .headerActionBtn': {
            cursor: 'pointer',
            flexShrink: 0,
            '& span': {
                fontSize: 18,
            },
        },
    },
    '& .commentList': {
        display: 'flex',
        flexDirection: 'column',
        gap: 15,
        padding: '10px 12px 12px 12px',
        '& .receivedRow': {
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
            '& .senderName': {
                marginLeft: 34,
                color: baseColors.greyPreset[30],
            },
            '& .receivedInner': {
                display: 'flex',
                flexDirection: 'row',
                gap: 4,
                alignItems: 'flex-start',
            },
            '& .avatarCircle': {
                width: 32,
                height: 32,
                borderRadius: '50%',
                backgroundColor: baseColors.greyPreset[45],
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                overflow: 'hidden',
                '& img': {
                    width: 32,
                    height: 32,
                },
            },
            '& .receivedBubble': {
                backgroundColor: baseColors.greyPreset[50],
                borderRadius: 4,
                padding: '12px 16px',
                flex: 1,
                gap: 10,
                '& .bubbleTypeBadge': {
                    backgroundColor: baseColors.greyPreset[55],
                    border: "1px solid ".concat(baseColors.greyPreset[40]),
                    borderRadius: 4,
                    padding: '4px 6px',
                    color: baseColors.bluePreset[40],
                    width: '100%',
                },
                '& .bubbleText': {
                    color: baseColors.greyPreset[10],
                    letterSpacing: '0.25px',
                },
            },
        },
        '& .sentRow': {
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'end',
            '& .sentBubble': {
                backgroundColor: baseColors.successPreset[30],
                borderRadius: 4,
                padding: '12px 16px',
                width: '80%',
                color: baseColors.fullWhite,
                gap: 10,
            },
        },
    },
    '& .inputArea': {
        gap: 8,
        padding: 20,
        '& .commentTypeRow': {
            width: '100%',
            alignItems: 'center',
        },
        '& .commentTypeLabel': {
            color: baseColors.greyPreset[10],
            fontWeight: 700,
            minWidth: 95,
        },
        '& .commentTypeSelectWrap': {
            position: 'relative',
            flex: 1,
            width: '100%',
            '&::after': {
                content: '""',
                position: 'absolute',
                right: 10,
                top: '50%',
                transform: 'translateY(-50%)',
                width: 0,
                height: 0,
                borderLeft: '5px solid transparent',
                borderRight: '5px solid transparent',
                borderTop: "5px solid ".concat(baseColors.greyPreset[10]),
                pointerEvents: 'none',
            },
        },
        '& .commentTypeSelect': {
            flex: 1,
            width: '100%',
            padding: '6px 32px 6px 12px',
            border: "1px solid ".concat(baseColors.greyPreset[20]),
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 700,
            outline: 'none',
            fontFamily: "'Nunito', sans-serif",
            color: baseColors.darkPreset[10],
            backgroundColor: baseColors.fullWhite,
            boxSizing: 'border-box',
            appearance: 'none',
        },
        '& .commentTypeSelect.placeholder': {
            color: baseColors.greyPreset[30],
        },
        '& .commentTypeSelect option': {
            color: baseColors.darkPreset[10],
        },
        '& .subjectInput': {
            width: '100%',
            padding: '6px 12px',
            border: "1px solid ".concat(baseColors.greyPreset[20]),
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 700,
            outline: 'none',
            fontFamily: "'Nunito', sans-serif",
            color: baseColors.darkPreset[10],
            backgroundColor: baseColors.fullWhite,
            boxSizing: 'border-box',
            '&::placeholder': {
                color: baseColors.greyPreset[30],
            },
        },
        '& .subjectInput.subjectInputMaxReached': {
            border: "1px solid ".concat(baseColors.errorPreset[10]),
        },
        '& .textareaWrap': {
            position: 'relative',
        },
        '& .messageTextarea': {
            width: '100%',
            padding: '13px 12px',
            border: "1px solid ".concat(baseColors.greyPreset[20]),
            borderRadius: 8,
            fontSize: 12,
            fontWeight: 700,
            outline: 'none',
            fontFamily: "'Nunito', sans-serif",
            resize: 'none',
            color: baseColors.darkPreset[10],
            backgroundColor: baseColors.fullWhite,
            boxSizing: 'border-box',
            display: 'block',
            '&::placeholder': {
                color: baseColors.greyPreset[30],
            },
        },
        '& .sendBtn': {
            position: 'absolute',
            bottom: 10,
            right: 10,
            width: 38,
            height: 26,
            borderRadius: 4,
            backgroundColor: baseColors.successPreset[30],
            border: 'none',
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
            '& span': {
                fontSize: 14,
                color: baseColors.fullWhite,
            },
        },
    },
}); });
